import React from 'react'
import { InputPesquisa, InstaBtt, Loading, Location, SearchAlert } from '../../Simple'
import { CompAnuncios, CompEmpresa, CompTorneio } from '../../Complex'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { BiChevronDown } from 'react-icons/bi'
import { AuthContext } from '../../../contexts/AuthContext'
import { Box, Button, Typography } from '@mui/material'
import CompProxAgend from './CompProxAgend/CompProxAgend'
import RouterHook from '../../../contexts/RouterHook'
import { ModalLocation } from '../../Modais'

export default function DeskEmpresas() {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttPg, inps, loads, actionsCtxEmps, modaisCE } = React.useContext(EmpresasContext)

  const ExibeTorneios = false

  const heightMainComponent = 100

  function ReturnSttPage() {
    if (modaisCE.modalL) {
      return actionsCtxEmps.handleModaisCE('modalL', false)
    } else {
      return serverRouter('back')
    }
  }

  React.useEffect(() => {
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => {
      window.removeEventListener('popstate', ReturnSttPage)
    }
  }, [modaisCE.modalL])

  return (
    <>
      <Box sx={{ maxHeight: `${heightMainComponent}%`, height: 'auto' }} className='contain-home-row'>
        <div className='contain-home-user'>
          <div className='contain-home-user-cabecalho'>
            <Typography variant='h5' fontFamily={'baloo-bhaina'}>
              Centros Esportivos
            </Typography>
            <div>
              <Button
                sx={{ p: 0, fontWeight: 'medium' }}
                className='btt-alterar-location'
                onClick={() => {
                  actionsCtxEmps.handleModaisCE('modalL', true)
                }}
              >
                <Location cidade={userUCtx.cidade?.nomeCidade} estado={userUCtx.cidade?.estado.nomeEstado} />
                <BiChevronDown className='btt-icon-down' size={30} />
              </Button>
            </div>
          </div>
          {/* Filtro de empresas */}
          <div className='contain-home-user-filtro'>
            <InputPesquisa
              input={inps.search}
              onChange={e => actionsCtxEmps.handleInps('search', e.target.value)}
              onClick={() => {}}
              textPlace={'Pesquisar por Centro Esportivo'}
              width={'100%'}
            />
          </div>
          <div className='contain-home-user-empresas'>
            {loads.empresas ? (
              <div className='contain-loading tw-h-full'>
                <Loading text={'Carregando...'} />
              </div>
            ) : sttPg.empresas.length ? (
              sttPg.empresas.map((emp, idx) => {
                return (
                  <CompEmpresa
                    key={idx}
                    empresa={emp}
                    onClick={() => {
                      actionsCtxEmps.SelectEmpresa(emp)
                      serverRouter('centro-esportivo', emp.username)
                    }}
                  />
                )
              })
            ) : userUCtx.usuario.cidade === null ? (
              <SearchAlert text={'Você precisa selecionar uma cidade para ter acesso as empresas'} />
            ) : (
              <SearchAlert text={'Nenhuma empresa encontrada'} />
            )}
          </div>
          <InstaBtt />
        </div>
        <div className='contain-home-functions'>
          {sttAuthCtx.isLogged && userUCtx.usuario && userUCtx.ultimoPedido !== null ? (
            <div className='contain-home-functions-proximo'>
              <CompProxAgend />
            </div>
          ) : (
            <></>
          )}
          {ExibeTorneios &&
            // Só mostra se tiver pelo menos um torneio
            sttPg.empresas?.some(emp => emp.torneios?.length > 0) && (
              <div className='contain-home-functions-proximo'>
                <Typography variant='h6' sx={{ fontWeight: 'bold', color: 'black', width: '100%', textAlign: 'center' }}>
                  Competições
                </Typography>
                <div className='contain-list-torneios'>
                  {sttPg.empresas?.some(emp => emp.torneios?.length > 0) && (
                    <>
                      {sttPg.empresas.map((emp, idx) => (
                        <React.Fragment key={idx}>
                          {emp.torneios?.map((torneio, idx2) => (
                            <React.Fragment key={idx2}>
                              <CompTorneio
                                nomeEmpresa={emp.nome}
                                fotoEmpresa={emp.urlFoto + emp.foto}
                                torneio={torneio}
                                onClick={() => {
                                  serverRouter('torneio', torneio.idtorneio)
                                }}
                              />
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </div>
              </div>
            )}
          <CompAnuncios />
        </div>
        {modaisCE.modalL && <ModalLocation show={modaisCE.modalL} onClose={() => actionsCtxEmps.handleModaisCE('modalL', false)} />}
      </Box>
      <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div
          className='rtz-banner'
          data-rtz-espaco-id='117'
          style={{ width: '728px', height: '90px', overflow: 'hidden' }}
          data-rtz-width='728'
          data-rtz-height='90'
          title='Espaço publicitário'
          data-rtz-display-formato='imagem_video'
          data-rtz-tipo-criativo='360'
          data-rtz-device='desktop'
        ></div>
      </Box>
    </>
  )
}
